<script setup lang="ts">
/**
 * App footer component.
 *
 * @component AppFooter
 */

/**
 * Current year for copyright.
 */
const year = new Date().getFullYear()

/**
 * App version from package.json.
 */
const version = __APP_VERSION__

/**
 * Git commit hash (short).
 */
const gitHash = __GIT_HASH__

/**
 * Show debug elements only in development or preview.
 */
const isDev = import.meta.env.DEV || window.location.hostname.includes('devel')
</script>

<template>
  <!-- Copyright -->
  <router-link to="/" class="link">
    <span>&copy; 2024 - {{ year }} Granite</span>
  </router-link>

  <!-- Version -->
  <span>v{{ version }} ({{ gitHash }})</span>

  <!-- Debug CSS spacer (dev only) -->
  <span v-if="isDev" class="debug-screen">
    <span>Size:&nbsp;</span>
    <span class="screen-is-t">T</span>
    <span class="screen-is-s">S</span>
    <span class="screen-is-m">M</span>
    <span class="screen-is-l">L</span>
    <span class="screen-is-w">W</span>
  </span>

  <!-- Theme indicator (dev only) -->
  <span v-if="isDev" class="debug-theme">
    <span>Theme:&nbsp;</span>
    <span class="theme-is-dark">Dark</span>
    <span class="theme-is-light">Light</span>
    <span class="theme-is-auto">[Auto]</span>
    <span class="theme-is-forced">[Forced]</span>
  </span>

  <!-- Spacer -->
  <span class="spacer"></span>

  <!-- Debug Auth link -->
  <router-link to="/debug/auth" class="link">
    Auth
  </router-link>
</template>
